import { render, staticRenderFns } from "./ArtistCredits.vue?vue&type=template&id=63b9a89a&"
import script from "./ArtistCredits.vue?vue&type=script&lang=js&"
export * from "./ArtistCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports